<template>
  <div class="item-query-container">
    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="layui-form-item">
        <div class="layui-input-wrap">
          <div class="layui-input-prefix">
            <i class="layui-icon layui-icon-search"></i>
          </div>
          <input
              type="text"
              v-model="searchQuery"
              placeholder="输入物品或怪物名称..."
              class="layui-input"
              lay-affix="clear"
          >
        </div>
      </div>
    </div>

    <!-- 内容容器：横向排列4个list-section -->
    <div class="content-wrapper">
      <!-- 1. 物品列表区域 -->
      <div class="list-section">
        <div class="section-content">
          <div class="item-list" v-if="filteredItems.length">
            <div
                v-for="(item,index) in filteredItems"
                :key="`item-${item[1]}-${index}`"
                @click="selectItem(item)"
                :class="{ active: selectedItem && selectedItem[1] === item[1] }"
            >
              <span style="color:red;">{{index+1}}.</span>{{ item[0] }}
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="fas fa-box-open"></i>
            <p>暂无物品数据</p>
          </div>
        </div>
      </div>

      <!-- 2. 怪物列表区域 -->
      <div class="list-section">
        <div class="section-header">
          <div v-if="!selectedItem">请先选择要查的物品</div>
          <div v-else>
            正在查询
            <span class="highlight-text">{{ selectedItem[0] }}</span>
            的出处
          </div>
        </div>
        <div class="section-content">
          <div class="monster-list" v-if="filteredMonsters.length">
            <div
                v-for="monster in filteredMonsters"
                :key="monster[1]"
                @click="selectMonster(monster)"
                :class="{ active: selectedMonster && selectedMonster[1] === monster[1] }"
            >
              {{ monster[0] }}
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedItem">该物品没有关联的怪物</p>
            <p v-else>请先选择一个物品</p>
          </div>
        </div>
      </div>

      <!-- 3. 怪物刷新地图区域 -->
      <div class="list-section">
        <div class="section-header">
          <div v-if="!selectedMonster">请先选择要查的怪物</div>
          <div v-else>
            正在查询
            <span class="highlight-text">{{ selectedMonster[0] }}</span>
            的刷新地
          </div>
        </div>
        <div class="section-content">
          <div class="map-list" v-if="refreshMaps.length">
            <div
                v-for="map in refreshMaps"
                :key="map.id"
                @click="selectMap(map)"
            >
              {{ map.name }} <span class="rate-badge">{{ map.refreshRate }}分钟/只</span>
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedMonster">该怪物没有刷新地图数据</p>
            <p v-else>请先选择一个怪物</p>
          </div>
        </div>
      </div>

      <!-- 4. 地图走法区域 -->
      <div class="list-section">
        <div class="section-header">
          <div v-if="!selectedMap">请先选择要查的地图</div>
          <div v-else>
            正在查询
            <span class="highlight-text">{{ selectedMap.name }}</span>
            的走法
          </div>
        </div>
        <div class="section-content">
          <div v-if="mapPaths.length" class="path-container">
            <div
                v-for="(pathGroup, index) in mapPaths"
                :key="index"
                class="path-group"
            >
              <div class="path-group-title">第{{ index + 1 }}种走法</div>
              <div
                  v-for="(path,indexff) in pathGroup"
                  :key="path.from + path.to"
                  class="path-item"
              >
                <span>{{indexff + 1}}.</span> 从<span style="color:royalblue;">{{ path.fromName }}</span>坐标:<span class="coord-badge">{{ path.fromKey }}</span>
                →<span style="color:rgb(255 7 188);">{{ path.toName }}</span>坐标:<span class="coord-badge">{{ path.toKey }}</span>
              </div>
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedMap">该地图没有路径数据</p>
            <p v-else>请先选择一个地图</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch} from 'vue';
//优化前的
export default {
  props: {
    stditemsData: {
      type: Array,
      required: true,
      default: () => []
    },
    monsterData: {
      type: Array,
      required: true,
      default: () => []
    },
    mapData: {
      type: Array,
      required: true,
      default: () => []
    },
    monsterRefresh: {
      type: Array,
      required: true,
      default: () => []
    },
    initialItemId: {
      type: Number,
      default: null
    }
  },
  setup(props) {
    // 状态管理
    const searchQuery = ref('');
    const selectedItem = ref(null);
    const selectedMonster = ref(null);
    const selectedMap = ref(null);

    // 初始物品ID处理（增加类型转换，避免ID不匹配）
    watch(
        () => props.initialItemId,
        (newVal) => {
          if (newVal && props.stditemsData.length) {
            const targetItemId = Number(newVal); // 统一转为数字
            const item = props.stditemsData.find(i => Number(i[1]) === targetItemId);
            if (item) {
              selectedItem.value = item;
            }
          }
        },
        //{ immediate: true } // 组件初始化时立即执行
    );

    // 过滤后的物品列表（保持不变）
    const filteredItems = computed(() => {
      if (!searchQuery.value) return props.stditemsData;
      const lowerQuery = searchQuery.value.toLowerCase();
      return props.stditemsData.filter(item =>
          item[0].toLowerCase().includes(lowerQuery)
      );
    });

    // 根据选中物品过滤怪物（核心修复1：ID类型统一 + 避免重复）
    const filteredMonsters = computed(() => {
      if (!selectedItem.value || !props.monsterRefresh.length) return [];

      // 统一物品ID为数字
      const targetItemId = Number(selectedItem.value[1]);
      const monsterIds = new Set(); // 去重

      props.monsterRefresh.forEach(refresh => {
        if (refresh.c_goods && Array.isArray(refresh.c_goods)) {
          refresh.c_goods.forEach(goods => {
            // 正确解析 [掉落率, 物品ID]，且统一物品ID为数字
            const [, itemId] = goods;
            if (Number(itemId) === targetItemId) {
              // 统一怪物ID为数字，避免字符串/数字不匹配
              monsterIds.add(Number(refresh.c_mongen_id));
            }
          });
        }
      });

      // 过滤怪物时，怪物ID也转为数字匹配
      return props.monsterData.filter(monster =>
          monsterIds.has(Number(monster[1]))
      );
    });

    // 根据选中怪物获取刷新地图（核心修复2：地图编码大小写兼容）
    const refreshMaps = computed(() => {
      if (!selectedMonster.value || !props.monsterRefresh.length) return [];

      // 统一怪物ID为数字
      const targetMonsterId = Number(selectedMonster.value[1]);
      const maps = [];
      const mapCodeSet = new Set(); // 避免同一地图重复显示

      props.monsterRefresh.forEach(refresh => {
        // 怪物ID数字匹配
        if (Number(refresh.c_mongen_id) === targetMonsterId && refresh.c_refresh && Array.isArray(refresh.c_refresh)) {
          refresh.c_refresh.forEach(refreshInfo => {
            // 地图编码转为小写，兼容大小写差异
            const mapCode = String(refreshInfo[0]).toLowerCase();
            const [, , refreshTime] = refreshInfo;

            // 去重逻辑
            if (mapCodeSet.has(mapCode)) return;
            mapCodeSet.add(mapCode);

            // 查找地图时，地图编码也转为小写匹配
            const mapInfo = props.mapData.find(map =>
                String(map[1]).toLowerCase() === mapCode
            );

            if (mapInfo) {
              maps.push({
                id: mapCode, // 存储小写编码，后续走法查询统一
                name: mapInfo[0],
                refreshRate: refreshTime || '未知'
              });
            }
          });
        }
      });

      return maps;
    });

    // 根据选中地图获取路径信息（核心修复3：走法编码大小写兼容）
    const mapPaths = computed(() => {
      if (!selectedMap.value || !props.mapData.length) return [];

      // 选中地图编码转为小写（与refreshMaps存储的编码一致）
      const targetMapCode = String(selectedMap.value.id).toLowerCase();
      const pathGroups = [];

      props.mapData.forEach(map => {
        // 地图编码小写匹配
        if (String(map[1]).toLowerCase() === targetMapCode && map[2] && Array.isArray(map[2])) {
          map[2].forEach((pathGroup) => {
            const groupPaths = [];
            if (!Array.isArray(pathGroup)) return;

            pathGroup.forEach(path => {
              if (path?.from && path?.to) {
                // 路径中的from/to编码都转为小写
                const fromCode = String(path.from).toLowerCase();
                const toCode = String(path.to).toLowerCase();

                // 查找来源/目标地图时，编码小写匹配
                const fromMap = props.mapData.find(m =>
                    String(m[1]).toLowerCase() === fromCode
                );
                const toMap = props.mapData.find(m =>
                    String(m[1]).toLowerCase() === toCode
                );

                if (fromMap && toMap) {
                  groupPaths.push({
                    from: path.from,
                    fromName: fromMap[0],
                    fromKey: path.fromkey || '未知',
                    to: path.to,
                    toName: toMap[0],
                    toKey: path.tokey || '未知'
                  });
                }
              }
            });

            if (groupPaths.length) {
              pathGroups.push(groupPaths);
            }
          });
        }
      });

      return pathGroups;
    });

    // 选择方法（保持不变）
    const selectItem = (item) => {
      selectedItem.value = item;
      selectedMonster.value = null;
      selectedMap.value = null;
    };

    const selectMonster = (monster) => {
      selectedMonster.value = monster;
      selectedMap.value = null;
    };

    const selectMap = (map) => {
      selectedMap.value = map;
    };

    return {
      searchQuery,
      selectedItem,
      selectedMonster,
      selectedMap,
      filteredItems,
      filteredMonsters,
      refreshMaps,
      mapPaths,
      selectItem,
      selectMonster,
      selectMap
    };
  }
};
</script>


<style scoped>
/* 物品查询组件独立样式表 */
/* 基础容器样式 */
.item-query-container {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0;
  position: relative;
  height: calc(100vh - 100px);
}

/* 搜索区域样式 */
.search-section {
  background: white;
  border-radius: 4px;
  margin-bottom: 15px;
  width:33%;
}

.search-section .layui-form-item {
  margin: 0;
}
.layui-input-wrap{
  width:100%;
}
.search-section .layui-input {
  border-radius: 4px;
  padding-left: 30px !important;
  height: 30px;
  border: 1px solid #e6e6e6;
}

.search-section .layui-input-prefix {
  color: #888;
  line-height: 30px;
}

/* 内容容器样式 */
.content-wrapper {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
  height: calc(100vh - 137px);
}

.content-wrapper::-webkit-scrollbar {
  display: none;
}

/* 列表区域样式 */
.list-section {
  flex: 0 0 320px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  height: 100%;
}

/* 列表标题栏样式 */
.section-header {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  padding: 0 10px;
  font-size: 12px;
  color: #333;
  background-color: #f5f5f5;
}

.highlight-text {
  color: #409eff;
  margin: 0 4px;
  font-size: 12px;
}

/* 列表内容区样式 */
.section-content {
  flex: 1;
  padding: 0 !important;
  box-sizing: border-box;
  overflow-y: auto;
  scrollbar-width: none;
  scrollbar-color: rgba(156, 156, 156, 0.6) transparent;
}

.section-content::-webkit-scrollbar {
  width: 0;
  transition: width 0.3s ease-in-out;
}

.section-content:hover::-webkit-scrollbar {
  width: 2px;
}

.section-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

.section-content::-webkit-scrollbar-thumb {
  background-color: rgba(156, 156, 156, 0.6);
  border-radius: 10px;
}

/* 列表项样式 */
.item-list, .monster-list, .map-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.item-list div, .monster-list div, .map-list div {
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: 30px;
  line-height: 30px;
  padding: 0 15px !important;
  font-size: 14px;
}

.item-list div:hover, .monster-list div:hover, .map-list div:hover {
  background-color: #409eff;
  color: #fff;
}

.item-list div.active, .monster-list div.active, .map-list div.active {
  background-color: #409eff;
  color: #fff;
  font-weight: 500;
}

.item-list div span[style="color:red;"] {
  margin-right: 8px;
}

/* 徽章样式 */
.rate-badge {
  font-size: 12px;
  padding: 1px 6px;
  border-radius: 8px;
  background-color: #f0f9ff;
  color: #1890ff;
  margin-left: auto;
}

.coord-badge {
  border-radius: 4px;
  background-color: #f0f9ff;
  color: #1890ff;
  font-size: 12px;
}

/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  gap: 10px;
  padding: 20px 0;
}

.empty-state i {
  font-size: 48px;
  opacity: 0.5;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
  text-align: center;
  padding: 0 10px;
}

/* 地图走法样式 */
.path-container {
  margin: 0;
  padding: 0;
  width: 100%;
}

.path-group {
  margin-bottom: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
}

.path-group-title {
  padding: 8px 12px;
  background-color: #f5f5f5;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
  width: 100%;
  box-sizing: border-box;
}

.path-item {
  padding: 0;
  align-items: center;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}


/* 移动端响应式样式 */
@media (max-width: 768px) {
  .search-section .layui-input {
    border-radius: 4px;
    padding-left: 30px !important;
    height: 30px;
    border: 1px solid #e6e6e6;
    width:100%;
  }
  .search-section{
    width:100%;
  }
  .item-query-container {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0;
    position: relative;
    height: calc(100vh - 90px);
  }
  .content-wrapper {
    flex-direction: column; /* 改为纵向排列 */
    overflow-x: hidden;
    overflow-y: auto;
    height: calc(100vh - 150px);
    gap: 10px;
  }

  .list-section {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    max-height: 200px;
  }
  .section-header {
    font-size: 13px;
  }

  .item-list div, .monster-list div, .map-list div {
    font-size: 13px;
    min-height: 36px;
    line-height: 36px;
  }

  .empty-state i {
    font-size: 36px;
  }
}

</style>